"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RangePicker = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var styled_components_1 = tslib_1.__importDefault(require("styled-components"));
var smartDate_1 = require("./smartDate");
var SelectableListItem_1 = require("../SelectableListItem");
var Label_1 = require("../../Typography/Label");
exports.RangePicker = function (_a) {
    var smartDateType = _a.smartDateType, datePickerType = _a.datePickerType, setStartDate = _a.setStartDate, setEndDate = _a.setEndDate, setSmartDateType = _a.setSmartDateType;
    var smartDatesForType = smartDate_1.SmartDates.get(datePickerType);
    var handleSelectSmartDate = function (newSmartDate) {
        var smartDateValue = smartDatesForType === null || smartDatesForType === void 0 ? void 0 : smartDatesForType.get(newSmartDate);
        if (smartDateValue) {
            setStartDate(smartDateValue.startDate);
            if (smartDateValue.endDate) {
                setEndDate(smartDateValue.endDate);
            }
            setSmartDateType(newSmartDate);
        }
    };
    var smartDateListItems = Object.entries(smartDate_1.SmartDateTypeOptions).map(function (_a) {
        var key = _a[0], value = _a[1];
        var dateRangeLabel = value;
        var active = smartDateType === value;
        return (react_1.default.createElement(SelectableListItem_1.SelectableListItem, { key: key, "data-testid": key, onClick: function () { return handleSelectSmartDate(dateRangeLabel); }, label: react_1.default.createElement(SelectableListItemText, null, dateRangeLabel), isSelected: active }));
    });
    return (react_1.default.createElement(StyledRangePicker, null,
        react_1.default.createElement(StyledLabel, null, "Smart Dates"),
        smartDateListItems));
};
var StyledRangePicker = styled_components_1.default.div(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  color: ", ";\n  font-family: ", ";\n  font-size: 1.2rem;\n  position: relative;\n"], ["\n  color: ", ";\n  font-family: ", ";\n  font-size: 1.2rem;\n  position: relative;\n"])), function (props) { return props.theme.colors.NTDarkGrey[500]; }, function (props) { return props.theme.fonts.robotoRegular; });
var SelectableListItemText = styled_components_1.default.div(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  line-height: 1.8rem;\n  margin: 0.8rem 0;\n  > i {\n    margin-left: 0.4rem;\n  }\n"], ["\n  display: flex;\n  align-items: center;\n  line-height: 1.8rem;\n  margin: 0.8rem 0;\n  > i {\n    margin-left: 0.4rem;\n  }\n"])));
var StyledLabel = styled_components_1.default(Label_1.Label)(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["\n  margin-left: 2.7rem;\n"], ["\n  margin-left: 2.7rem;\n"])));
var templateObject_1, templateObject_2, templateObject_3;
